import { render, staticRenderFns } from "./SpecificationHeader.vue?vue&type=template&id=1fe9634d&scoped=true&"
import script from "./SpecificationHeader.vue?vue&type=script&lang=js&"
export * from "./SpecificationHeader.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationHeader.vue?vue&type=style&index=0&id=1fe9634d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9634d",
  null
  
)

export default component.exports